import { useParams, useNavigate } from "react-router-dom";

/* TEMP DATA (Later replace with API) */
const partners = [
  {
    id: 1,
    service: "Salon",
    businessName: "Style Hub Salon",
    address: "MG Road, Bangalore",
    city: "Bangalore"
  },
  {
    id: 2,
    service: "Salon",
    businessName: "Glow Beauty Salon",
    address: "Andheri West",
    city: "Mumbai"
  },
  {
    id: 3,
    service: "Plumber",
    businessName: "Quick Fix Plumbing",
    address: "Sector 21",
    city: "Pune"
  }
];

function ServicePartners() {
  const { serviceName } = useParams();
  const navigate = useNavigate();

  const filteredPartners = partners.filter(
    (p) => p.service === serviceName
  );

  return (
    <div className="partners-page">
      <h2 className="section-title">
        {serviceName} Service Providers
      </h2>

      {filteredPartners.length === 0 ? (
        <p>No partners registered for this service.</p>
      ) : (
        <div className="partner-list">
          {filteredPartners.map((p) => (
            <div className="partner-card" key={p.id}>
              <h3>{p.businessName}</h3>
              <p>{p.address}</p>
              <p>{p.city}</p>

              <button
                className="top-btn"
                onClick={() => navigate(`/partner/${p.id}`)}
              >
                View Profile
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* 🔴 THIS LINE IS REQUIRED */
export default ServicePartners;
